<div class="card mt-4">
    <div class="text-xl font-semibold mb-4">Vorfälle</div>

    @if (rows.length === 0) {
        <div class="text-muted-color p-4">
            Keine Vorfälle verzeichnet.
        </div>
    } @else {
        <p-table
            [value]="rows"
            stripedRows="true"
            [rowHover]="true"
            [paginator]="rows.length > 10"
            [rows]="10"
            responsiveLayout="scroll"
            size="small"
        >
            <ng-template #header>
                <tr>
                    <th style="width: 8rem;">Datum</th>
                    <th style="width: 12rem;">Strecke</th>
                    <th>Beschreibung</th>
                </tr>
            </ng-template>
            <ng-template #body let-incident>
                <tr>
                    <td style="white-space: nowrap;">{{ incident.day_real | date: 'dd.MM.yyyy' }}</td>
                    <td>{{ incident.circuits_name }}</td>
                    <td class="incident-cell">{{ incident.description }}</td>
                </tr>
            </ng-template>
        </p-table>
    }
</div>
